import { useParams } from "react-router";
import { useNative, useRail } from "../../../../shared/phone/media";
import { GoalPage } from "../../goal/GoalWizard";
import { CommandCenter } from "../CommandCenter";
import { HomeNative } from "./HomeNative";

/**
 * Home (`/command`) and a goal's pages (`/goals/:goalId/*`). A computer keeps the Command Center and the
 * goal's page. A phone draws Home, and a goal over it. On an iPad a goal's own page sits beside Home's list;
 * its deeper pages (plan, Get ready, ads) take the whole width. Why one route element for both: the list
 * stays the same list, scrolled where it was, as the goal beside it changes.
 */
export function HomeRoute() {
  const native = useNative();
  const rail = useRail();
  const { goalId, "*": rest = "" } = useParams();
  if (goalId === undefined) return native ? <HomeNative /> : <CommandCenter />;
  if (rail && rest.replace(/\/+$/, "") === "") return <HomeNative goal={<GoalPage />} />;
  return <GoalPage />;
}
